import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-table-simple',
  templateUrl: './table-simple.component.html',
  styleUrls: ['./table-simple.component.scss'],
  imports: [CommonModule, TableModule, TranslateModule]
})
export class TableSimpleComponent {

  @Input() tableHeaders: any[];
  @Input() tableData:any[];

  constructor() { }


}
